/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EligibilityRequestAltParamsInner
 */
export interface EligibilityRequestAltParamsInner {
    /**
     * 
     */
    name?: string;
    /**
     * 
     */
    value?: string;
}

/**
 * Check if a given object implements the EligibilityRequestAltParamsInner interface.
 */
export function instanceOfEligibilityRequestAltParamsInner(value: object): value is EligibilityRequestAltParamsInner {
    return true;
}

export function EligibilityRequestAltParamsInnerFromJSON(json: any): EligibilityRequestAltParamsInner {
    return EligibilityRequestAltParamsInnerFromJSONTyped(json, false);
}

export function EligibilityRequestAltParamsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): EligibilityRequestAltParamsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'value': json['value'] == null ? undefined : json['value'],
    };
}

export function EligibilityRequestAltParamsInnerToJSON(json: any): EligibilityRequestAltParamsInner {
    return EligibilityRequestAltParamsInnerToJSONTyped(json, false);
}

export function EligibilityRequestAltParamsInnerToJSONTyped(value?: EligibilityRequestAltParamsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'value': value['value'],
    };
}

